import * as React from "react";
const SvgFiRrHouseDay = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-house-day_svg__a)">
      <path
        fill="#062147"
        d="m22.465 12.589-3.5-2.739a3.99 3.99 0 0 0-4.93 0l-3.5 2.739a3.97 3.97 0 0 0-1.536 3.15V20c0 2.206 1.794 4 4 4h7c2.206 0 4-1.794 4-4v-4.261a3.98 3.98 0 0 0-1.534-3.15M22 20c0 1.103-.897 2-2 2h-7c-1.103 0-2-.897-2-2v-4.261c0-.62.28-1.193.768-1.575l3.5-2.739a2 2 0 0 1 2.464 0l3.5 2.739c.488.382.768.956.768 1.575zm-4-3v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1M6.771 14.379a1 1 0 0 1-1.06.319l-1.502 1.507a.996.996 0 0 1-1.414.002 1 1 0 0 1-.002-1.415L4.25 13.33a6.5 6.5 0 0 1-1.172-2.835H1a1 1 0 0 1 0-2h2.078a6.5 6.5 0 0 1 1.176-2.829L2.793 4.205a.999.999 0 1 1 1.414-1.414l1.461 1.461a6.46 6.46 0 0 1 2.83-1.176L8.5.998A1 1 0 1 1 10.499 1l-.002 2.076a6.5 6.5 0 0 1 2.834 1.172l1.462-1.457a1 1 0 1 1 1.412 1.417l-1.506 1.501a1 1 0 0 1-1.728.928A4.49 4.49 0 0 0 9.499 5a4.505 4.505 0 0 0-4.5 4.5 4.49 4.49 0 0 0 1.637 3.472 1 1 0 0 1 .134 1.408z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-house-day_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHouseDay;
